import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline"
import OptionsSection from "./OptionsSection"

/**
 * Options extension (admin side): what a buyer picks on a product — sizes,
 * colors, a customization — and the Variants grid the variant-axis options
 * span, one SKU per combination with its own stock.
 *
 * The values come from option sets, CMS content of type StoreOptionSet
 * (edited in the CMS admin, with the StoreOptionValuesEditor field editor),
 * or are an option's own. The tab writes the product's `options` and
 * `variants` through the form. The server half is
 * aldoo-na/store/product/extensions/options, the storefront's selectors
 * aldoo-ra/Store/extensions/options/storefront.jsx.
 */
export const StoreProductExtension = {
  id: "options",
  label: "Options & variants",
  description: "What the buyer picks: option sets (sizes, colors), the variants they span with their SKU and stock, price deltas",
  icon: AdjustmentsHorizontalIcon,
  group: { id: "options", label: "Options", description: "The options a buyer picks and the variants they span." },
  section: {
    component: OptionsSection,
    label: "Options",
    icon: AdjustmentsHorizontalIcon,
    order: 300,
  },
}
